module.exports = __webpack_public_path__ + "static/media/dotted-arrow-short.1791df02.svg";